// Palette.styl clone to use in styled components

// Basic colors
export const colorBlack = '#000000';
export const colorWhite = '#ffffff';

export const colorWhiteTransparent = 'rgba(255, 255, 255, 0.8)';
export const colorBlackShadow = 'rgba(0, 0, 0, 0.1)';
export const colorBlackShadowDark = 'rgba(0, 0, 0, 0.2)';

//
// Primary Colors
// ==============
//
// Practically all colors in the application should draw from this palette.
//

// Purples (full color / lightened tint)
export const colorPunch = '#4c5def';
export const colorBubbles = '#dbdffc';

export const colorJuice = '#423f87';
export const colorFizz = '#d9d9e7';

export const colorSoda = '#2c1f2f';
export const colorPop = '#d5d2d5';

// Grays (light to dark)
export const colorDew = '#f9f9f9';
export const colorFog = '#ececec';
export const colorRain = '#c6c6c6';
export const colorStorm = '#595959';
export const colorTwister = '#373737';
export const colorBlackout = '#202020';
export const colorGrayText = '#606060';
export const colorGrayBorder = '#e5e5e5';

export const colorSilver = '#C3C3C3';
export const colorGrey = '#7E7E7E';

// Grays (opacity based)
export const colorBlack10 = 'rgba(0,0,0,0.1)';
export const colorBlack30 = 'rgba(0,0,0,0.3)';
export const colorBlack50 = 'rgba(0,0,0,0.5)';

//
// Secondary Colors
// ================
//
// Statuses, accents, marketing, and other weird one-offs.
// These colors come in pairs: the full color and a lighter variation.
//

// Red
export const colorHollywood = '#ef4e51';
export const colorCowabunga = '#fd8672';

// Yellow
export const colorBuzz = '#fec76c';
export const colorLemonade = '#fee4ad';

// Green
export const colorMoney = '#1bb580';
export const colorCents = '#aaf2da';

// Pink
export const colorConfetti = '#f36381';
export const colorCake = '#fecdd2';

// Purple
export const colorManhattan = '#7f50fb';
export const colorBrooklyn = '#acb9fd';

// Blue
export const colorFloat = '#1276d1';
export const colorGlitter = '#5cc5fc';

// Black
export const colorCharcoal = '#191919';

// Third parties
export const colorFacebook = '#1877f2';
export const colorFacebookHover = '#166fe5';
export const colorTwitter = '#1d9bf0';
export const colorLinkedin = '#0073b1';
export const colorLinkedinHover = '#004182';

export const colorZoom = '#2d8cff';
export const colorVimeo = '#86c9ef';
export const colorSplashStudio = '#ff7a5c';
